export default __webpack_public_path__ + "static/media/internet.b861474d.svg";